import { render, staticRenderFns } from "./BarGraphIcon.vue?vue&type=template&id=239ae99e&scoped=true"
import script from "./BarGraphIcon.vue?vue&type=script&lang=js"
export * from "./BarGraphIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239ae99e",
  null
  
)

export default component.exports